import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CreditCardService, ErrorHandlerService } from 'epay-library';
import { SMIPayStatus } from 'src/app/features/common/models/SMI Pay- Credit Card/smi-pay-status.model';
import { EpayExtendedService } from 'src/app/helpers/services/epay-extended.service';

@Component({
  selector: 'credit-card-success-common',
  templateUrl: './credit-card-success-common.component.html'
})
export class CreditCardSuccessCommonComponent implements OnInit {
  @Input() baseurl = '';
  //@Input() encryptedTransactionId = '';
  @Input() clientId = '';

  paymentDate = '';
  empName = '';
  confirmationId = '';
  amount = 0;
  processFee = 0;
  totalAmount = 0;
  transactionId = '';
  payorType = '';

  errorMessage = '';

  smiPayRequest: SMIPayStatus = {} as SMIPayStatus;

  status = '';
  orderId = '';
  tid = '';


  constructor(
    private router: Router,
    private creditcardservice: CreditCardService,
    private errorhandleservice: ErrorHandlerService,
    private epayExtendedService: EpayExtendedService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      //console.log(params);
      this.tid = params['externalId'] || params['externalid'];
      this.orderId = params['id'];
      this.status = params['Status'];
    });


    this.smiPayRequest = {
      status: this.status,
      orderId: this.orderId,
      transactionId: this.tid
    };

    this.epayExtendedService.getSMIPayStatus(this.baseurl, this.smiPayRequest).subscribe({
      next: (response: any) => {
          this.paymentDate = response.date;
          this.empName = response.name;
          this.confirmationId = response.confirmationId;
          this.amount = +response.amount;
          this.processFee = +response.fee;
          this.totalAmount = +response.totalAmount;
          //this.transactionId = response.transactionId;
          this.transactionId = this.tid;
          this.payorType = '';
      },
      error: (error: any) => {
        console.log(error);
        this.logError(error);
        this.handleError(error.status);
      }
    }); 

  }

  Print() {
    window.print();
  }

  GoToHomePage() {
    this.router.navigateByUrl('home');
  }

  logError(error: Error) {
    this.errorhandleservice.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    this.errorhandleservice.handleErrorMessage(error, this.baseurl);
  }
}

